// extracted by mini-css-extract-plugin
module.exports = {"nav-link-icon":"OIG-rW_V mr1","navLinkIcon":"OIG-rW_V mr1"};